/** Agent UI theme: dark (default) | light */

export const AGENT_THEME_STORAGE_KEY = "agent-ui-theme";
export const AGENT_THEME_DARK = "dark";
export const AGENT_THEME_LIGHT = "light";

export function getAgentTheme() {
  if (typeof window === "undefined") return AGENT_THEME_DARK;
  const stored = window.localStorage.getItem(AGENT_THEME_STORAGE_KEY);
  if (stored === AGENT_THEME_LIGHT || stored === AGENT_THEME_DARK) return stored;
  return AGENT_THEME_DARK;
}

export function applyAgentTheme(theme) {
  const resolved = theme === AGENT_THEME_LIGHT ? AGENT_THEME_LIGHT : AGENT_THEME_DARK;
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-agent-theme", resolved);
  }
  if (typeof window !== "undefined") {
    window.localStorage.setItem(AGENT_THEME_STORAGE_KEY, resolved);
    window.dispatchEvent(
      new CustomEvent("agent-theme-changed", { detail: { theme: resolved } })
    );
  }
  return resolved;
}

export function toggleAgentTheme() {
  const next =
    getAgentTheme() === AGENT_THEME_DARK ? AGENT_THEME_LIGHT : AGENT_THEME_DARK;
  return applyAgentTheme(next);
}

export function initAgentTheme() {
  return applyAgentTheme(getAgentTheme());
}

export function isAgentDarkTheme(theme = getAgentTheme()) {
  return theme !== AGENT_THEME_LIGHT;
}
